export const props = Object.freeze({
  /**
   * Message text rendered next to the walk-in icon. Ignored when the default slot is provided.
   *
   * @type {String}
   * @default undefined
   */
  message: {
    type: String,
    default: undefined,
  },
  /**
   * Horizontal alignment of the message row. "start" stretches across the available width;
   * "center" sizes to content and centres itself.
   *
   * @type {String}
   * @storybook-control select
   * @default "start"
   */
  align: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center"].includes(value),
  },
  /**
   * When set, render a trailing help icon that shows this string via sp-tooltip on hover/focus.
   *
   * @type {String}
   * @default undefined
   */
  tooltip: {
    type: String,
    default: undefined,
  },
});
